import fetch from '@/plugin/axios'

// 查询
export function getList () {
  return fetch({
    url: '/api/common/sys-config/list',
    method: 'Get'
  })
}

// 修改
export function getEditSet (query) {
  return fetch({
    url: '/api/common/sys-config/set',
    method: 'Post',
    params: query
  })
}

export function updateSets (data) {
  return fetch({
    url: '/api/common/sys-config/sets',
    method: 'Post',
    data: data
  })
}
